import React, { Fragment, useState } from "react";
import styled, { css } from "styled-components";
import {
  Button,
  FormGroup,
  ContentBlock,
  Dropdown,
  TagSelector,
  Icon,
  Select,
  Input,
  Switch,
  RadioGroup,
  FormFooter,
  Tag,
  Tooltip,
  Table,
  FormCaption
} from "xsolla-uikit";

import { vc, currencies, vcpacks, currs, currsReal } from "../../data/vc";
import PAh2 from "../PAh2";
import CardNew, { CardItem } from "../PAcardNew";
import { Link } from "react-router-dom";
import PAvcPacks from "./PAvcPacks";
import {
  PAinfoCollapsible,
  CssVCimage,
  CssVCimages,
  CssSquareButton,
  CssThTd,
  PAvCpreview
} from "../uikit2";
import PAvirtualItems from "../ingame/PAvirtualItems";
import { PAvcTable } from "./PAvcPacks";
import { PAviPreview } from "../ingame/PAviItem";

import { PAstoreGroups } from "./../ingame/PAstoreGroups";

export const allColumns = [
  {
    label: "Status",
    value: "status",
    width: "1.8fr",
    required: true
  },
  {
    label: "Internal id",
    value: "internal",
    width: "1fr"
  },
  {
    label: "Subscription plan",
    value: "plan",
    width: "2.1fr"
    // required: true,
  },
  {
    label: "Email / Username or ID",
    value: "email",
    width: "3.4fr"
    // required: true,
  }
];

let colsInitial = [
  "email",
  "internal",
  "plan",
  // 'dateCreation',
  "dateNext",
  "status",
  "charge"
  // 'action',
  // 'comment',
];

export const PAprices = ({
  //TODO: not used
  items = [...allColumns],
  columns = [...colsInitial],
  setColumns = () => void 0
}) => {
  return (
    <div className="">
      <TagSelector
        name="locales"
        items={items}
        fields={{
          getAll: () => items,
          push: a => setColumns([...columns, a]),
          remove: index => {
            const newCols = [...columns];
            newCols.splice(index, 1);
            console.log("newCols = ", newCols);
            setColumns([...newCols]);
          }
        }}
      />
    </div>
  );
};

export const PApriceAll = () => {
  const [columns, setColumns] = useState([...colsInitial]);
  return (
    <PAprices
      items={[...allColumns]}
      columns={[...colsInitial]}
      setColumns={setColumns}
    />
  );
};

const getImage = rw => {
  debugger;
  if (rw["image_url"]) return rw["image_url"];
  return currs[rw["currencySku"]]["image_url"];
};

const image_url =
  "//cdn3.xsolla.com/img/misc/images/0c59a7698d4f66c1008b27ee752089b7.png";

const columns = [
  // {
  //   width: '3%',
  //   id: 'Order',
  //   name: '',
  //   sticky: true,
  //   fieldGetter: (rw)=> {
  //     let i = 0
  //     vc.forEach((oneV, ind) => {
  //       if (oneV['id'] === rw['id']) i = ind;
  //     })
  //     return (<div className="">
  //       <div class="ui-table__drag-handle"></div>
  //     <div
  //       style={{display: 'flex', justifyContent:'center'}}
  //       >{i + 1}</div>
  //     </div>);
  //   }
  // },

  {
    width: "5%",
    id: "Name",
    name: "Package image and name",
    fieldGetter: rw => {
      return (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "64px 1fr",
            placeContent: "center",
            alignItems: "center",
            gridColumnGap: 8
          }}
        >
          <CssVCimages
            // image_url={getCurrencyData(rw['sku'])}
            image_url={rw["image_url"] || currs[rw["currencySku"]]["image_url"]}
            amount={rw["amount"]}
          />
          <div style={{ fontSize: 13 }}>
            <b>{rw["title"]}</b>
            <br />
            {rw["description"]["en"]}
          </div>
        </div>
      );
    }
  },

  {
    width: "3%",
    id: "Amount",
    name: "Amount",
    fieldGetter: rw => {
      return (
        <Dropdown
          align="left"
          // autosize={true}
          type="inform"
          separated={false}
          content={{
            size: "lg",
            title: "Currency amount",
            description: (
              <div style={{ width: 320 }}>
                <PApresets noPrices={true} />

                <FormGroup label="Set new amount" indentation="lg">
                  <div className="l_flex">
                    <div style={{ width: 108, marginRight: 8 }}>
                      <Input
                        size="sm"
                        name="basic-input"
                        input={{
                          value: `${rw["amount"]}`
                          // onChange: this.onChange
                        }}
                      />
                    </div>
                    {currs[rw["currencySku"]]["titleMultiple"]}
                  </div>
                </FormGroup>

                <FormGroup>
                  <Button disabled={true} size="sm" appearance="secondary">
                    Save new quantity
                  </Button>
                </FormGroup>
              </div>
            )
          }}
        >
          <CssThTd
            interactive={true}
            onClick={true}
            style={{
              // marginRight: 24,
              fontSize: 14
            }}
          >
            {rw["amount"]}
          </CssThTd>
        </Dropdown>
      );
    }
  },



  // {
  //   width: '10%',
  //   id: 'bonus',
  //   name: 'Bonus',
  //   fieldGetter: 'bonus'
  // },
  // {
  //   width: '10%',
  //   id: 'priceOld',
  //   name: 'Original price',
  //   fieldGetter: (rw) => `${rw['prices_array'][0]['name']} ${rw['prices_array'][0]['value']}`
  // },
];



const colCurrency = {
    width: "5%",
    id: "currency",
    name: "Currency",
    fieldGetter: rw => {
      return (
        <Dropdown
          align="left"
          // autosize={true}
          type="inform"
          separated={false}
          content={{
            size: "lg",
            title: "Currency type",
            description: (
              <div style={{ width: 320 }}>
                <FormGroup label="Package currency" indentation="lg">
                  <RadioGroup
                    direction="column"
                    input={{
                      value: rw["currencySku"]
                      // onChange: e => this.setState({ value: e.target.value })
                    }}
                    options={[
                      ...Object.keys(currs).map((oneCurrId, ind) => {
                        let oneCurr = currs[oneCurrId];
                        // if (oneCurr['real']) return null;
                        return {
                          label: <PAvCpreview {...oneCurr} name={true} />,
                          radioValue: oneCurrId
                        };
                      })
                    ]}
                  />
                </FormGroup>

                <FormGroup>
                  <Button disabled={true} size="sm" appearance="secondary">
                    Save changes
                  </Button>
                </FormGroup>
              </div>
            )
          }}
        >
          <CssThTd
            interactive={true}
            onClick={true}
            // style={{marginRight: 36}}
          >
            <PAvCpreview {...currs[rw["currencySku"]]} />
          </CssThTd>
        </Dropdown>
      );
    }
  }



const getPrice = (rw, index) => {
  let newPrice =
    rw["prices_array"][index]["value"] -
    Math.round(rw["prices_array"][index]["value"] * rw["bonus"]);
  return <strong>{`${rw["prices_array"][index]["name"]} ${newPrice}`}</strong>;
};

const rowActions = {
  width: "3%",
  id: "Name",
  name: (
    <Link to="/microtransactions/new_currency">
      <Tooltip label="Create new currency">
        <div
          style={{
            bottom: "-2px",
            position: "relative"
          }}
        >
          <Icon size={22} name="add-circle" />
        </div>
      </Tooltip>
    </Link>
  ),
  fieldGetter: () => (
    <Dropdown
      align="right"
      // autosize={true}
      separated={false}
      options={[
        { label: "Settings", icon: "settings" },
        { label: "Duplicate", icon: "copy" },
        { label: "Delete", color: "#eb002f", icon: "delete" }
      ]}
    >
      <Icon name="more" />
    </Dropdown>
  )
};

export default function PAvirtualCurrency({
  history,
  view = "row",
  packs = vcpacks
}) {
  const [cardType, setCardType] = useState(view);

  const [newKey, setNewKey] = useState(false);

  const [tab, setTab] = useState();






  const getCurColls = dontShow => {
    let cols2 = [];
    // let currsWithReal = {...currsReal, ...currs};
    let currsWithReal = { ...currsReal, ...currs };
    packs &&
      Object.keys(currsWithReal).forEach((oneCurId, ind) => {
        // console.log('currs[oneCurId] = ', currs[oneCurId]);

        let oneCurr = currsWithReal[oneCurId];
        if (
          typeof dontShow === "undefined" ||
          (dontShow && oneCurId !== dontShow)
        )
          cols2 = [
            ...cols2,
            {
              width: "5%",
              id: oneCurId,
              name: (
                <div className="l_flex">
                  <div className="l_flex">
                    <Link
                      to="/microtransactions/new_currency"
                      style={{ color: "#747e8a" }}
                    >
                      <div className="l_flex">
                        {!!oneCurr["image_url"] && (
                          // <Tooltip label={oneCurr['titleMultiple']}>
                          <PAvCpreview {...oneCurr} name={true} />
                        )
                        // </Tooltip>
                        }

                        {!oneCurr["image_url"] && (
                          <span style={{ marginRight: "4px" }}>
                            {oneCurr["titleMultiple"]}
                          </span>
                        )}
                        {!oneCurr['real'] && <span
                          style={
                            {
                              // marginLeft: '4px',
                            }
                          }
                        >
                          <Icon size={18} name="edit" />
                        </span>}
                      </div>
                    </Link>
                  </div>
                </div>
              ),
              // name: 'Pack price in',
              fieldGetter: rw => {
                if (oneCurr["id"] === rw["currencySku"]) return <span style={{color: "#747e8a"}}>✕</span>;

                return (
                  <Dropdown
                    size="lg"
                    type="inform"
                    // autosize={true}
                    separated={false}
                    content={{
                      title: `Price in ${oneCurr["title"]}`,
                      description: (
                        <FormGroup>
                        <FormGroup indentation='sm'></FormGroup>
                          <FormGroup indentation="sm">
                            <div className="l_flex">
                              <div style={{ width: 108, marginRight: 8 }}>
                                <Input
                                  size="sm"
                                  disabled={true}
                                  input={{
                                    // name: 'with-icon',
                                    value: rw["amount"]
                                    // onChange: this.handleInput
                                  }}
                                  extra={
                                    <PAvCpreview
                                      image_url={
                                        currsWithReal[rw["currencySku"]][
                                          "image_url"
                                        ]
                                      }
                                    />
                                  }
                                  offset="left"
                                />
                              </div>
                              <span style={{ margin: "0 1em" }}>=</span>
                              <div style={{ width: 108, marginRight: 8 }}>
                                <Input
                                  size="sm"
                                  focused={true}
                                  name="basic-input"
                                  input={{
                                    // value: rw['prices'][oneCurId] ? rw['prices'][oneCurId] : '',
                                    value: rw["prices"][oneCurId]
                                      ? rw["prices"][oneCurId]
                                      : ""
                                    // onChange: this.onChange
                                  }}
                                  extra={
                                    oneCurr["image_url"] ? (
                                      <PAvCpreview
                                        image_url={oneCurr["image_url"]}
                                      />
                                    ) : (
                                      "USD"
                                    )
                                  }
                                  offset="left"
                                />
                              </div>
                            </div>
                          </FormGroup>


                          <FormGroup>
                            {rw["amount"]} ✗ {rw["prices"][rw['currencySku']]} = {rw["amount"] * rw["prices"][rw['currencySku']]}
                          </FormGroup>

                          <FormFooter>
                            <Button
                              disabled={true}
                              size="sm"
                              appearance="secondary"
                            >
                              Save new price
                            </Button>
                          </FormFooter>
                        </FormGroup>
                      )
                    }}
                  >
                    <CssThTd
                      interactive={true}
                      onClick={true}
                      // style={{marginRight: 36}}
                    >
                      {rw["prices"][oneCurId] ? (
                        <PAvCpreview
                          {...oneCurr}
                          amount={rw["prices"][oneCurId]}
                          name={false}
                        />
                      ) : (
                        <span className="xsui-form-group__label">
                          Set price
                        </span>
                      )}
                    </CssThTd>
                  </Dropdown>
                );
              }
            }
          ];

        // Object.keys(currs[curr]['prices']).forEach((oneCurId, ind)=>{
        //   cols2 = [...cols2, {
        //     width: '10%',
        //     id: oneCurId,
        //     // name: `Pack price in ${currs[oneCurId]['title']}`,
        //     fieldGetter: (rw) => {
        //       return rw['prices'][oneCurId]
        //     },
        //   }]
        // })
      });
    return cols2;
  };




  const makeColumns = (dontShow) => {

    let cols = [...getCurColls(dontShow)]

    if (!dontShow || dontShow === 'all') cols = [colCurrency, ...cols]

    return [
      ...cols
      // {
      //   width: '10%',
      //   id: 'Name',
      //   name:  <Link to="/microtransactions/new_currency"><Button appearance="flatten">Add currency</Button></Link>,
      //   fieldGetter: ()=> <Link to="/microtransactions/new_currency">
      //     <Button appearance="flatten"><Icon name="add-circle"/></Button>
      //   </Link>
      // },
    ];
  };

  const [filt, setFilt] = useState("all");

  const [cols, setCols] = useState([columns, ...makeColumns(filt)]);

  const makeFlat = () => {
    let vcFlat = [];
    vc.forEach((row, ind) => {
      vcFlat = [...vcFlat, ...row["packs"]];
    });
    return vcFlat;
  };

  const makeVc = (packs, filter) => {
    let vcFlat = [];
    packs &&
      Object.keys(packs).forEach((packId, ind) => {
        let row = packs[packId];
        if (
          typeof filter === "undefined" ||
          filter === "all" ||
          row["currencySku"] === filter
        )
          vcFlat = [...vcFlat, row];
      });
    return vcFlat;
  };

  return (
    <FormGroup>
      <FormGroup indentation="lg">
        <ContentBlock
        appearance="flatten"
        >

          <FormGroup indentation="lg">
            <div style={{ display: "flex", alignItems: "center" }}>
              <PAh2 tag="h3" title="Currencies" indentation="xs"></PAh2>{" "}
              <CssCTA>
                <Link to="/microtransactions/new_currency"><Button appearance="flatten"><Icon name="circle-plus" size={24}/></Button></Link>
              </CssCTA>
            </div>
          </FormGroup>


          <FormGroup indentation="lg">
          <PAstoreGroups
            handleEdit={(editCur, e)=> {
              console.log('editCur = ', editCur);
              e.preventDefault();
              history.history.push(`/ingame/new_currency`)
            }}
            active={filt}
            handleClick = {(nw)=>setFilt(nw)}
            groups={[
              {
                name: 'All Currencies',
                id: 'all',
              },
              ...Object.keys(currs).map((oneCurrId, ind) => {
                  let oneCurr = currs[oneCurrId];
                  // if (oneCurr['real']) return null;
                  return {
                    name: oneCurr['title'],
                    id: oneCurrId,
                    image_url: oneCurr['image_url']
                  };
                })]} />
          </FormGroup>
          <br/>



        {/* </ContentBlock> */}
      {/* </FormGroup> */}

      {/* <FormGroup indentation="lg"> */}
        {/* <ContentBlock
        // appearance="flatten"
        > */}


          <FormGroup indentation="lg">
            <div style={{ display: "flex", alignItems: "center" }}>
              <PAh2 tag="h3" title="Currencу packages" indentation="xs"></PAh2>

              {" "}
                <CssCTA>

                <CssTableFix>
                  <Dropdown
                    align="left"
                    // autosize={true}
                    type="inform"
                    separated={false}
                    content={{
                      size: "lg",
                      title: "Currency amount",
                      description: (
                        <div>
                          <PApresets />
                        </div>
                      )
                    }}
                  >
                    <Button appearance="flatten"><Icon name="circle-plus" size={24}/></Button>
                  </Dropdown>
                </CssTableFix>



                </CssCTA>

                {/* <FormGroup label="Show packs for"> */}
                <div style={{flexGrow:1, display: 'flex', justifyContent: 'flex-end'}}>
                  <Select
                    autosize={true}
                    size="sm"
                    input={{
                      // value: Object.keys(currs)[0],
                      value: filt,
                      onChange: e => setFilt(e)
                    }}
                    extra="Show: "
                    options={[
                      {
                        label: "All currencies",
                        value: "all"
                      },
                      ...Object.keys(currs).map((oneCurrId, ind) => {
                        let oneCurr = currs[oneCurrId];
                        // if (oneCurr['real']) return null;
                        return {
                          label: <PAvCpreview {...oneCurr} name={true} />,
                          value: oneCurrId
                        };
                      })
                    ]}
                  />
                  </div>
                {/* </FormGroup> */}

            </div>
          </FormGroup>



          <CssTableFix>
            <Table
              compact={true}
              renderEmptyMessage={() => (
                <div>
                  <FormGroup>
                    <Link to="/microtransactions/new_currency">
                      <Button appearance="outline-secondary">
                        Create new currency
                      </Button>
                    </Link>
                  </FormGroup>
                </div>
              )}
              style={{ width: "100%" }}
              horizontalScroll={false}
              columns={[...columns, ...makeColumns(filt), rowActions]}
              rows={makeVc(packs, filt)}
            />
          </CssTableFix>

          {packs && (
            <FormFooter>
              <CssTableFix>
                <Dropdown
                  align="left"
                  // autosize={true}
                  type="inform"
                  separated={false}
                  content={{
                    size: "lg",
                    title: "Currency amount",
                    description: (
                      <div>
                        <PApresets />
                      </div>
                    )
                  }}
                >
                  {/* <Link to="/microtransactions/new_currency"> */}
                  <Button appearance="outline-secondary" size="sm">
                    Create currency package
                  </Button>
                  {/* </Link> */}
                </Dropdown>
              </CssTableFix>
            </FormFooter>
          )}

          {/* {vc.map((oneV, ind) => {
              // let dataForCard = makeVc(oneV)
              return (
                <FormGroup indentation="xs" key={`login_${ind}`}>

                  <Table
                    compact={true}
                    renderEmptyMessage = {()=><div>
                      <FormGroup>
                        <Link to="/microtransactions/new_currency"><Button appearance="outline-secondary">Create package</Button></Link>
                      </FormGroup>
                    </div>}
                    style={{width: '100%'}}
                    horizontalScroll={true}
                    columns={columns}
                    rows={oneV['packs']}
                  />
              </FormGroup>
    )})} */}
        </ContentBlock>
      </FormGroup>
    </FormGroup>
  );
}

const CSScards = styled.div`
  ${({ cardType }) =>
    cardType === "row"
      ? css`
          width: 100%;
          display: grid;
          grid-template-columns: 1fr;
          grid-column-gap: 24px;
          /* grid-auto-rows: minmax(min-content, max-content); */
          grid-row-gap: 24px;
          place-content: stretch;
        `
      : css`
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
          grid-column-gap: 24px;
          grid-row-gap: 24px;
          place-content: stretch;
        `};
`;

const CssCardItem = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  flex-grow: 1;
  ${({ cardType }) =>
    cardType === "row"
      ? css`
          height: 220px;
        `
      : css``};
`;

const CssTableFix = styled.div`
  & .xsui-table__scroll-wrapper {
    overflow: visible;
  }
  & .xsui-dropdown__container--size-md {
    max-height: none;
    max-width: none;
  }
`;

export const PApresets = ({
  rw = {
    title: "Some Gold Coins",
    amount: 10,
    currencySku: "gold",
    image_url: null, //берется дефолтная картинка валюты
    description: {
      en: ""
    },
    prices: {
      USD: "0.99",
      gold: "1.99",
      BRZ: "9.99",
      silver: "19.99"
    }
  },
  noPrices
}) => {
  return (
    <FormGroup label="Select from presets" indentation="lg">
      <div
        style={{ minWidth: 320, border: "1px solid #d8dee8", borderRadius: 6 }}
        className="xsui-tag-selector"
      >
        {/* <div className="xsui-tag-selector__item">
                <Tag>
                  5
                </Tag>
              </div>
              <div className="xsui-tag-selector__item">
                <Tag>
                  10
                  </Tag>
              </div>
              <div className="xsui-tag-selector__item">
                <Tag>20 {currs[rw['currencySku']]['titleMultiple']}</Tag>
              </div>
              <div className="xsui-tag-selector__item">
                <Tag>50 {currs[rw['currencySku']]['titleMultiple']}</Tag>
              </div> */}

        <div
          value={1}
          className="xsui-dropdown__item xsui-dropdown__item--appearance-row"
          data-value={1}
          style={{ width: "100%" }}
        >
          <div className="xsui-dropdown-item__entry" style={{ width: "100%" }}>
            <div className="xsui-dropdown-item__row">
              <div
                className="xsui-dropdown__item__label"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div style={{ width: 180 }}>
                  10 {currs[rw["currencySku"]]["titleMultiple"]}
                </div>

                {!noPrices && (
                  <div style={{ width: 160 }}>
                    <div>
                      <b>19.99 USD</b>
                    </div>
                    <div style={{ color: "#747e8a", fontSize: 13 }}>
                      5% discount
                    </div>
                  </div>
                )}

                {!noPrices && (
                  <div style={{ width: 160 }}>
                    <div>
                      <b>300 Golden Coins</b>
                    </div>
                    <div>5% discount</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div
          value={1}
          className="xsui-dropdown__item xsui-dropdown__item--appearance-row"
          data-value={1}
          style={{ width: "100%" }}
        >
          <div className="xsui-dropdown-item__entry" style={{ width: "100%" }}>
            <div className="xsui-dropdown-item__row">
              <div
                className="xsui-dropdown__item__label"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div style={{ width: 180 }}>
                  50 {currs[rw["currencySku"]]["titleMultiple"]}
                </div>

                {!noPrices && (
                  <div style={{ width: 160 }}>
                    <div>
                      <b>29.99 USD</b>
                    </div>
                    <div style={{ color: "#747e8a", fontSize: 13 }}>
                      5% discount
                    </div>
                  </div>
                )}

                {!noPrices && (
                  <div style={{ width: 160 }}>
                    <div>
                      <b>800 Golden Coins</b>
                    </div>
                    <div>5% discount</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div
          value={1}
          className="xsui-dropdown__item xsui-dropdown__item--appearance-row"
          data-value={1}
          style={{ width: "100%" }}
        >
          <div className="xsui-dropdown-item__entry" style={{ width: "100%" }}>
            <div className="xsui-dropdown-item__row">
              <div
                className="xsui-dropdown__item__label"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div style={{ width: 180 }}>
                  100 {currs[rw["currencySku"]]["titleMultiple"]}
                </div>

                {!noPrices && (
                  <div style={{ width: 160 }}>
                    <div>
                      <b>39.99 USD</b>
                    </div>
                    <div style={{ color: "#747e8a", fontSize: 13 }}>
                      10% discount
                    </div>
                  </div>
                )}

                {!noPrices && (
                  <div style={{ width: 160 }}>
                    <div>
                      <b>1400 Golden Coins</b>
                    </div>
                    <div>20% discount</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {!noPrices && (
        <FormFooter>
          <Link to="/microtransactions/new_currency">
            <Button appearance="outline" size="sm">
              Create
            </Button>
          </Link>
        </FormFooter>
      )}
    </FormGroup>
  );
};




const CssCTA = styled.div`
  /* flex-grow: 1; */
  display: flex;
  /* justify-content: flex-end; */
  margin-left: 1em;
  margin-top: 4px;
`;